import { render, staticRenderFns } from "./DangeourBIllingTariffDialog.vue?vue&type=template&id=7f97a3ef&scoped=true"
import script from "./DangeourBIllingTariffDialog.vue?vue&type=script&lang=ts"
export * from "./DangeourBIllingTariffDialog.vue?vue&type=script&lang=ts"
import style0 from "./DangeourBIllingTariffDialog.vue?vue&type=style&index=0&id=7f97a3ef&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f97a3ef",
  null
  
)

export default component.exports